import { createSelector } from 'reselect';

import { getCompany } from './company.selectors';

const getObConfig = createSelector(getCompany, ({ obConfig }) => obConfig);

export const selectObAccounts = createSelector(getObConfig, ({ accounts }) => accounts);

export const selectObAccountStrategies = createSelector(
  getObConfig,
  ({ accountStrategies }) => accountStrategies,
);

export const selectObConfigInitialValues = createSelector(
  getObConfig,
  ({ configuration }) => configuration,
);
